/** A traded volume as the search results show it: $1.2M above a million, else $345K. */
export const formatVolume = (volume: number) =>
    `$${volume >= 1e6 ? `${(volume / 1e6).toFixed(1)}M` : `${(volume / 1e3).toFixed(0)}K`}`;
